import React from 'react';

/**
 * Renders basic markdown formatting in message text:
 * **bold** → <strong>bold</strong>
 * *italic* → <em>italic</em>
 * Preserves line breaks
 */
const FormattedMessage = ({ text, className = '' }) => {
  if (!text) return null;

  // Split by line breaks first
  const lines = text.split('\n');

  return (
    <div className={`${className} whitespace-pre-wrap`}>
      {lines.map((line, lineIdx) => (
        <React.Fragment key={lineIdx}>
          {lineIdx > 0 && '\n'}
          {formatLine(line)}
        </React.Fragment>
      ))}
    </div>
  );
};

function formatLine(line) {
  // Match **bold** and *italic* patterns
  const parts = [];
  let remaining = line;
  let key = 0;

  while (remaining.length > 0) {
    // Check for **bold**
    const boldMatch = remaining.match(/\*\*(.+?)\*\*/);
    // Check for *italic* (but not **)
    const italicMatch = remaining.match(/(?<!\*)\*(?!\*)(.+?)(?<!\*)\*(?!\*)/);

    let firstMatch = null;
    let matchType = null;

    if (boldMatch && italicMatch) {
      if (boldMatch.index <= italicMatch.index) {
        firstMatch = boldMatch;
        matchType = 'bold';
      } else {
        firstMatch = italicMatch;
        matchType = 'italic';
      }
    } else if (boldMatch) {
      firstMatch = boldMatch;
      matchType = 'bold';
    } else if (italicMatch) {
      firstMatch = italicMatch;
      matchType = 'italic';
    }

    if (firstMatch) {
      // Add text before match
      if (firstMatch.index > 0) {
        parts.push(<React.Fragment key={key++}>{remaining.substring(0, firstMatch.index)}</React.Fragment>);
      }
      // Add formatted text
      if (matchType === 'bold') {
        parts.push(<strong key={key++} className="font-semibold">{firstMatch[1]}</strong>);
      } else {
        parts.push(<em key={key++}>{firstMatch[1]}</em>);
      }
      remaining = remaining.substring(firstMatch.index + firstMatch[0].length);
    } else {
      parts.push(<React.Fragment key={key++}>{remaining}</React.Fragment>);
      remaining = '';
    }
  }

  return parts;
}

export default FormattedMessage;
